// extracted by mini-css-extract-plugin
export default {"brand":"BrandPrices-RCc3E__brand","price":"BrandPrices-j8bLM__price","zzca":"BrandPrices-sJm60__zzca","saleIcon":"BrandPrices-DaF+F__saleIcon"};